import {
    useQueryClient,
    useMutation,
    UseMutationResult,
} from '@tanstack/react-query'
import { IRuleSet } from '../../interfaces'
import { deleteRuleSet } from '../../../../services/dtServices'

export const useDeleteRuleSet = (
    orgId: string,
    entityId: string,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRuleSet>>,
    Error,
    string
> => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (ruleSetId: string) => {
            return deleteRuleSet(orgId, ruleSetId)
        },
        onMutate: (ruleSetId: string) => {
            queryClient.setQueryData(
                ['rulesets', orgId, entityId],
                (prevRuleSets: any) =>
                    prevRuleSets?.data?.filter(
                        (ruleSet: IRuleSet) => ruleSet.id !== ruleSetId,
                    ) as IRuleSet[],
            )
        },
        //refetch rules after mutation,
        onSettled: () =>
            queryClient.invalidateQueries({
                queryKey: ['rulesets', orgId, entityId],
            }),
    })
}
